import ContactListContainer from "../chat/ContactListContainer";
import ContactsWrapper from "../chat/ContactsWrapper";
import { EmptyConversationStatus } from "../chat/EmptyConversationStatus";

export default function EmptyChatPage({
  setShowContactList,
  showContactList,
}: {
  setShowContactList: () => void;
  showContactList: boolean;
}) {
  return (
    <div className="w-full  h-full  md:px-6    py-6  px-4 md:py-0 md:pb-4">
      <div className="w-full relative flex h-full flex-col  md:rounded-md md:shadow overflow-hidden md:flex-row   bg-white">
        <aside className="hidden bg-white sticky top-0 md:flex xl:flex-col flex-shrink-0 h-full  w-72  ltr:border-r rtl:border-l border-gray-200 overflow-y-auto">
          <ContactListContainer />
        </aside>
        {!showContactList && (
          <div className="h-full flex flex-col  bg-white flex-1 ">
            <div className="w-full overflow-hidden md:overflow-y-auto  h-full   md:px-8  flex flex-col flex-grow">
              <EmptyConversationStatus
                setShowContactList={setShowContactList}
              />
            </div>
          </div>
        )}
        {showContactList && (
          <div className="flex flex-col h-full  md:hidden">
            <ContactsWrapper />
          </div>
        )}
      </div>
    </div>
  );
}
